/*
Internships
 */

$('.work-based-learning').on('click',function(e){
    var $internship=$(this);
    if($internship.hasClass('busy')) return;
    $internship.addClass('busy');
    addWaiting();
    $.ajax({
        type: "POST",
        url: basePath + "/wp-content/plugins/mega-pathway/assets/scripts/ajax-internships.php",
        data: {
            //type: $internship.attr,
            type: $internship.attr('data-which'),
            id: $internship.attr('id'),
        },
        dataType: 'text',
        success: function (data) {
            var $id = getAjaxData(data);
            //console.log($id);
            var $button =document.getElementById($id);
            //console.log($button.innerHTML);
            if($button.innerHTML=="SAVE"){
                $button.innerHTML="REMOVE";
                $button.classList.add('disabled');
                $button.dataset.which="remove";
            }
            else if($button.innerHTML=="REMOVE"){
                $button.innerHTML="SAVE";
                $button.classList.remove('disabled');
                $button.dataset.which="save";
            }
            $('#waiting').remove();
            $internship.removeClass('busy');
        },
        error: function(xhr, desc, err) {
            $('#waiting').remove();
            $internship.removeClass('busy');
            console.log(xhr);
            console.log("internship: " + desc + "\nError:" + err);

        },
    });

});

$('.my-opportunity').on('click', function (e) {
    e.preventDefault();

    var $internship = $(this);
    var action = $internship.attr('data-which');
    if($internship.hasClass('busy')) return;
    $internship.addClass('busy');

    function closeConfirmModal() {
        $(document).off('click.confirmDelete click.confirmCancel');
        $('.fw-notification').remove();
        $('#overlay, .overlay').remove();
        $('.remove-internship.busy').removeClass('busy');
    }

    function processOpportunityAjax() {
        addWaiting();

        $.ajax({
            type: "POST",
            url: "/wp-content/plugins/mega-pathway/assets/scripts/ajax-internships.php",
            data: {
                type: action,
                id: $internship.attr('id')
            },
            dataType: 'html',
            success: function (data) {
                var id = getAjaxData(data);
                //console.log(id);

                var button = document.getElementById(id);
                var count = document.getElementById("title-count");
                var tense = document.getElementById("title-tense");
                var newcount = Number(count.innerHTML);
                var OTense = 'Opportunities';

                if ((newcount - 1) == 1) OTense = 'Opportunity';

                count.innerHTML = "" + (newcount - 1) + "";
                tense.innerHTML = OTense;

                //console.log(newcount - 1);

                button.parentElement.parentNode.removeChild(button.parentElement);

                id = getAjaxData(data);
                //console.log(id);
                //console.log(button.innerHTML);

                if (button.innerHTML == "SAVE") {
                    button.innerHTML = "REMOVE";
                    button.classList.add('disabled');
                    button.dataset.which = "remove";
                } else if (button.innerHTML == "REMOVE") {
                    button.innerHTML = "SAVE";
                    button.classList.remove('disabled');
                    button.dataset.which = "save";
                }

                $('#waiting').remove();
                $internship.removeClass('busy');
            },
            error: function (xhr, desc, err) {
                $('#waiting').remove();
                $internship.removeClass('busy');
                //console.log(xhr);
                //console.log("internship: " + desc + "\nError:" + err);
            }
        });
    }

    if ($internship.hasClass('remove-internship')) {
        closeConfirmModal();

        addOverlay(
            'fw-notification',
            '<h3>Are you sure you want to delete this opportunity?</h3><p class="centered">It will be removed from your saved opportunities list. Click Delete to continue.</p><p class="centered"><a href="#" class="btn secondary cancel">Cancel</a><a href="#" class="btn primary delete red">Delete</a></p>'
        );

        $(document).one('click.confirmDelete', '.fw-notification .delete', function (e) {
            e.preventDefault();
            closeConfirmModal();
            processOpportunityAjax();
        });

        $(document).one('click.confirmCancel', '.fw-notification .cancel', function (e) {
            e.preventDefault();
            closeConfirmModal();
        });

        return;
    }

    processOpportunityAjax();
});

$(".internshipStatus").change( function () {
    $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
            InternshipID: $(this).attr("data-id"),
            which: $(this).attr("data-which"),
            val: $(this).val(),
            action: 'fw_update_internship'
        }, // serializes the form's elements.
        dataType: "json",
        success: function (data) {
            window.location.reload();
            if (data.errors.length > 0) {
                for (var i = 0; i < data.errors.length; i++) {
                    //$cur.children('.errors').append('<p class="error">'+data.errors[i]+'</p>');
                }
            } 
        },
        error: function () {},
    });
    window.location.reload();
});

$(".OpportunityFavorite").on("click", function () {
    $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
            InternshipID: $(this).attr("data-id"),
            which: $(this).attr("data-which"),
            val: $(this).attr("data-manual_val"),
            action: 'fw_update_internship'
        }, // serializes the form's elements.
        dataType: "json",
        success: function (data) {
            window.location.reload();
            if (data.errors.length > 0) {
                for (var i = 0; i < data.errors.length; i++) {
                    //$cur.children('.errors').append('<p class="error">'+data.errors[i]+'</p>');
                }
            } 
        },
        error: function () {},
    });
    window.location.reload();
});
